import TextArea from 'antd/es/input/TextArea'
import { StatusMemberRegisterWaiting } from 'app/api/event/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { useChangeStatusMemberRegister } from 'app/react-query/hook/event'
import { useAppSelector } from 'app/redux/hooks'
import { useRef } from 'react'

export const ModalRejectMember = ({ id }: { id?: number }) => {
  const user = useAppSelector(state => state?.user)?.profile
  const refModal = useRef<IRefModal>({})

  const [form] = BaseForm.useForm<{ reason?: string }>()

  const { mutateAsync: mutateAsyncUpdate, isLoading } =
    useChangeStatusMemberRegister()

  const handleSubmit = async (values?: { reason?: string }) => {
    if (!id) return
    const res = await mutateAsyncUpdate({
      id,
      status: StatusMemberRegisterWaiting.REJECTED,
      reason: values?.reason,
      approvedById: +(user?.member?.id ?? 0),
    })
    if (res) {
      refModal?.current?.hide?.()
    }
  }

  return (
    <BaseModalComponent
      ref={refModal}
      titleModal="Từ chối đăng ký"
      buttonOpenModal={
        <BaseButton
          children="Từ chối"
          onClick={() => refModal.current?.open?.()}
          type="text"
        />
      }
      handleSubmit={form?.submit}
      isLoadingConfirm={isLoading}
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseSpace size={8}>
            <BaseText children={'Lý do từ chối'} fontWeight="medium" />
            <BaseForm.Item
              hiddenLabel
              style={{ marginBottom: 0 }}
              name={'reason'}
              rules={[
                {
                  required: true,
                  message: 'Vui lòng nhập lý do từ chối',
                },
              ]}
            >
              <TextArea placeholder="Vui lòng nhập lý do từ chối" />
            </BaseForm.Item>
            <BaseText
              children={`Lưu ý: Bạn cần nhập lý do từ chối để đoàn viên biết tại sao họ không được phê duyệt`}
              colorText="statesOrangeColor"
              opacity="0.8"
            />
          </BaseSpace>
        </BaseForm>
      }
    />
  )
}
